import { render, staticRenderFns } from "./MessageUsers.vue?vue&type=template&id=021c4576&"
import script from "./MessageUsers.vue?vue&type=script&lang=ts&"
export * from "./MessageUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports